/* eslint-disable react/jsx-no-useless-fragment */

import { Conditional } from '@consumidor-positivo/aurora';

import { MMChance, MMRewardHighlights } from '../../../types';

import { ChanceTag } from './components/ChanceTag';
import { BenefitTag } from './components/BenefitTag';

import './styles.scss';

type MMTagProps = {
  chances?: MMChance;
  benefit?: MMRewardHighlights;
};

export const MMTag = ({ benefit, chances }: MMTagProps) => {
  return <Conditional condition={!!benefit} renderIf={<BenefitTag benefit={benefit} />} renderElse={<ChanceTag chance={chances} />} />;
};
